var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emty"},[_c('p',[_c('img',{attrs:{"alt":"","src":require("@/assets/kong.png")}}),_c('span',[_vm._v("暂无更多")])])])}]

export { render, staticRenderFns }